import { ComparisonToggleTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/comparisonToggle.trackingInfo";

import { EnrichedAnalyticsEvent } from "@/utils/analytics/analytics.types";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";

export interface GoogleAnalyticsComparisonToggleImpression
    extends GoogleAnalyticsMinimumDataset {
    info: {
        action: "open" | "close";
    };
}

export const getGoogleAnalyticsComparisonToggleImpression = (
    data: EnrichedAnalyticsEvent<ComparisonToggleTrackingInfo>
): GoogleAnalyticsComparisonToggleImpression => {
    return {
        event: GoogleAnalyticsEvents.ComparisonToggle,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        info: {
            action: data.payload.eventData.action
        }
    };
};
